import { FunctionsError } from 'firebase/functions';
import getCallableFirebaseFunction from '../../../utilities/getCallableFirebaseFunction';

export interface SessionResponse {
  jti: string;
  expiresAt: number;
  platform: string;
  buildPath: string;
  appId: string;
  tunnelUrl?: string;
}

const startIntrospectionSessionFn = getCallableFirebaseFunction(
  'startIntrospectionSession',
);

function isFirebaseFunctionError(error: unknown): error is FunctionsError {
  return Boolean(
    typeof error === 'object' &&
    error &&
    'code' in error &&
    typeof (error as any).code === 'string',
  );
}

export async function startIntrospectionSession(
  buildId: string,
  platform: string,
  appId?: string,
): Promise<SessionResponse> {
  try {
    const result = await startIntrospectionSessionFn({
      buildId,
      platform,
      appId,
    });
    return result.data as SessionResponse;
  } catch (error) {
    if (isFirebaseFunctionError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
}

export function normalizePlatform(input: string): 'mac' | 'windows' | 'linux' {
  const normalized = input.toLowerCase();

  if (['mac', 'macos', 'darwin'].includes(normalized)) return 'mac';
  if (['windows', 'win'].includes(normalized)) return 'windows';
  if (normalized === 'linux') return 'linux';

  throw new Error(
    `Invalid platform: ${input}. Must be one of: mac, windows, linux`,
  );
}
